import { notification } from "antd";
import { Functions } from "../Common";

import { polygonStartString, selectedPolygonTypes } from "../Common/Constants";
import { havePermission } from "../../permissions";
import LAYERS_PERMISSIONS from "../../permissions/Layers.json";
const { AreaPolygons } = selectedPolygonTypes;

const { getLegend } = Functions;

const coloursMapping = {
	//Residential
	RESIDENTIAL: "#8be56e",
	COMMERCIAL: "#f1f105",
	INDUSTRIAL: "#f50905"
};
const generatePolygons = fileDate => {
	const polygons = {};

	if (!Array.isArray(fileDate)) {
		notification.error({
			message: "Error",
			description: "Invalid data format"
		});
		return polygons;
	}

	if (fileDate.length === 0) {
		notification.error({
			message: "Error",
			description: "No Area Polygon data found"
		});
		return polygons;
	}

	fileDate.forEach((polygon, index) => {
		const polygonCoordinates = polygon.coordinates.map(coordinate => {
			return { lat: coordinate.lat, lng: coordinate.lng };
		});

		const polygonArea = polygon.area;
		const fillColor = coloursMapping[polygonArea];
		const id = `${polygonStartString[AreaPolygons]}-${index}`;
		const polygonObject = {
			id,
			coordinates: polygonCoordinates,
			style: { fillColor, strokeColor: fillColor, zIndex: 5 },
			showInfo: false,
			filterData: {
				value: polygonArea
			}
		};

		polygons[id] = polygonObject;
	});

	return polygons;
};

const generatePolygonsLegends = (fileDate, legendHandler) => {
	if (!havePermission(LAYERS_PERMISSIONS.LAYER_LAND_TYPE_LEGEND)) return {};
	const legends = [];
	const uniqueAreas = new Set();
	fileDate.forEach(polygon => {
		uniqueAreas.add(polygon.area);
	});

	uniqueAreas.forEach(area => {
		const legend = getLegend({
			text: area,
			color: coloursMapping[area] || "GREEN",
			onClick: () => {
				legendHandler && legendHandler(area);
			}
		});
		legends.push(legend);
	});

	return legends;
};

const AreaPolygon = {
	polygons: data => {
		return generatePolygons(data);
	},
	legends: (fileDate, legendHandler) => {
		return generatePolygonsLegends(fileDate, legendHandler);
	}
};

export default AreaPolygon;
export { generatePolygons, generatePolygonsLegends };
